<template>
  <AppDrawer v-model="isDrawerOpen" dialog-titel="Mer info om lurarnas skick">
    <template #header>
      <div class="flex gap-8 flex-col">
        <h2 class="heading-xs">Nummerflytt</h2>
        <p>
          Välj att få ett nytt nummer eller behåll ditt nuvarande nummer med
          enkel nummerflytt.
        </p>
      </div>
    </template>
    <div class="flex gap-18 flex-col">
      <h3 class="heading-xxs">Nytt nummer</h3>
      <p>
        kommer få ett nytt nummer tillsammans med det nya simkortet vi skickar
        till dig senare.
      </p>

      <h3 class="heading-xxs">Behåll nummer, står på dig</h3>
      <p>
        Du kan välja att behålla ett nummer som du redan äger. Du kan flytta
        ditt nummer från en annan operatör eller behålla som Halebop kund. Du
        kommer att få ett sms med en kod för att verifiera att numret är ditt.
        Halebop kommer sen att sköta nummerflytten vilket vanligtvis tar ca. 5
        dagar.
      </p>

      <h3 class="heading-xxs">Behåll nummer, står på en annan person</h3>
      <p>
        Om du vill behålla ett nummer som någon annan äger väljer du "Behåll
        nummer, står på en annan person" i kassan. Fyll i den nuvarande ägarens
        personnummer och numret du vill ta över. Den nuvarande ägaren behöver
        godkänna en överlåtelse och portering med BankID. Halebop kommer sen att
        sköta nummerflytten.
      </p>

      <h3 class="heading-xxs">Behåll nummer som är ur bruk</h3>
      <p>Om ditt nummer är ur bruk behöver du kontakta vår chattsupport.</p>
    </div>
  </AppDrawer>
</template>

<script lang="ts" setup>
defineProps({});
const isDrawerOpen = defineModel<boolean>();
</script>

<style scoped lang="scss"></style>
